import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AngularMaterialModule } from 'src/app/angular-material.module';
import { DialogCloseModule } from 'src/app/shared/components/dialog-close/dialog-close.module';
import { DialogSaveCloseModule } from 'src/app/shared/components/dialog-save-close/dialog-save-close.module';
import { DynamicFormModule } from 'src/app/shared/components/dynamic-form/dynamic-form.module';
import { FieldsModule } from 'src/app/shared/components/fields/fields.module';
import { TableResponsiveModule } from 'src/app/shared/components/table-responsive/table-responsive.module';
import { DialogContainerModule } from 'src/app/shared/dialog-container/dialog-container.module';
import { LayoutCrudIndexModule } from '../shared/layout-crud-index/layout-crud-index.module';
import { MatDialogModule } from '@angular/material/dialog';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatIconModule } from '@angular/material/icon';
import { DownloadProgressDialogComponent } from './download-progress-dialog-component/download-progress-dialog-component.component';
import { CustomerAcessIndexSelectComponent } from './crud-index/crud-index-select.component';
import { CustomerAcessCrudIndex } from './crud-index/crud-index';
import { CustomerAcessCESComponent } from './crud-ces/crud-ces.component';
import { CustomerAcessRoutingModule } from './customer-acess-routing.module';
import { CustomerAcessIndexComponent } from './crud-index/crud-index.component';
import { AcessDescriptionComponent } from './file-description/file-description.component';

@NgModule({
  declarations: [
    CustomerAcessCESComponent,
    CustomerAcessCrudIndex,
    CustomerAcessIndexComponent,
    CustomerAcessIndexSelectComponent,
    AcessDescriptionComponent,
    DownloadProgressDialogComponent,
  ],
  imports: [
    CommonModule,
    CustomerAcessRoutingModule,
    AngularMaterialModule,
    FlexLayoutModule,
    FormsModule,
    ReactiveFormsModule,
    DynamicFormModule,
    FieldsModule,
    TableResponsiveModule,
    DialogCloseModule,
    DialogSaveCloseModule,
    DialogContainerModule,
    LayoutCrudIndexModule,
    MatDialogModule,
    MatProgressBarModule,
    MatIconModule,
  ],
  exports: [
    CustomerAcessIndexComponent,
    CustomerAcessIndexSelectComponent
  ]
})
export class CustomerAcessModule { }
